import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails9 = () => {
  const psfData = {
    title: "Utpann PSF",
    category: "Phosphate Solubilizing Fungal",
    image: "/assets/Product/img9.png",
    description:
      "PSF (Phosphate Solubilizing Fungi) helps convert insoluble phosphorus in soil into a form easily absorbed by plants. It promotes strong root development, better flowering, and improved energy transfer in crops. Regular use of PSF enhances nutrient efficiency, crop yield, and soil fertility over time.",
    price: "800",
    priceNote: "Per 500gm Pack (Gujarat) (Inc GST)",
    recommendations: [
      "All Crops",
      "Improve Phosphorus Availability",
      "Strengthens Root",
    ],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      { label: "Spore count", value: "minimum 1x10(6) spores/gram" },
      {
        label: "Contamination Level",
        value: "1x10(3) cells per gram for carrier based preparation",
      },
      { label: "pH", value: "6.0-7.7" },
      {
        label: "Efficiency Character",
        value:
          "The strain should be capable of solubilizing at least 30mg/liter",
      },
    ],
    packaging: [
      { label: "Bulk", value: "1000 MT FIBC" },
      { label: "Standard Pack", value: "500gm" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Enhances phosphorus availability in soil",
      "Improves root development and plant vigor",
      "Increases nutrient uptake efficiency",
      "Supports sustainable agriculture with eco-friendly biofertilization",
      "Enhance microbial activity in the soil",
      "Promotes early seed germination and plant establishment",
      "Improves soil structure and fertility overtime",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={psfData} />

        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails9;
